/* eslint-disable no-console */
export class ErrorWithCause extends Error {
  constructor(
    readonly message: string,
    readonly cause: Error
  ) {
    super();
  }
}

type SeverityLevel = 'error' | 'warning' | 'info' | 'debug';

export interface LogInput {
  value: string | Error | unknown;
  severity: SeverityLevel;
  cause?: Error | unknown;
  extra?: {
    requestUrl?: string;
    requestMethod?: string;
    requestBody?: unknown;
    queryParams?: unknown;
    errorCode?: number;
  };
}

function logConsoleDebug(value: LogInput['value'], cause?: LogInput['cause']) {
  if (cause) {
    console.debug(value, cause);
  } else {
    console.debug(value);
  }
}

function logConsoleInfo(value: LogInput['value'], cause?: LogInput['cause']) {
  if (cause) {
    console.info(value, cause);
  } else {
    console.info(value);
  }
}

function logConsoleWarning(value: LogInput['value'], cause?: LogInput['cause']) {
  if (cause) {
    console.warn(value, cause);
  } else {
    console.warn(value);
  }
}

function logConsoleError(value: LogInput['value'], cause?: LogInput['cause']) {
  if (cause) {
    console.error(value, cause);
  } else {
    console.error(value);
  }
}

export function logToConsole({ value, severity, cause }: LogInput) {
  switch (severity) {
    case 'debug':
      logConsoleDebug(value, cause);
      break;
    case 'info':
      logConsoleInfo(value, cause);
      break;
    case 'warning':
      logConsoleWarning(value, cause);
      break;
    case 'error':
      logConsoleError(value, cause);
      break;
    default:
      throw new Error('No handling for severity level ' + severity);
  }
}

export function castErrorMessageToString(errorMessage: LogInput['value']) {
  if (typeof errorMessage === 'string') {
    return errorMessage;
  }

  return JSON.stringify(errorMessage);
}
